import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LICENSE_FEATURE_KEY } from './keys';
import { licenseReducer } from './reducers/license.reducer';
import { LicenseEffects } from './effects/license.effects';

export function provideLicenseStore(): EnvironmentProviders[] {
    return [provideState(LICENSE_FEATURE_KEY, licenseReducer), provideEffects(LicenseEffects)];
}
